import { render } from "./TableReport.vue?vue&type=template&id=088b408a"
import script from "./TableReport.vue?vue&type=script&lang=js"
export * from "./TableReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__